<template>
<div class="chapter">
<div class="inner_page">
<p class="dedi">For Sylvie and Phoebe Sanders.<br/>Thanks for riding this flying carpet.</p>
<p class="imagec"><img alt="Images" src="images/dedi.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?0492e161